var exports = {
  "w": "Footer__1Jdtlr",
};

module.exports = exports;
